import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { loadCldr } from '@syncfusion/ej2-base';
import App from './containers/App/App';
import i18n from './services/i18n';
import * as serviceWorker from './serviceWorker';

loadCldr(
  require('cldr-data/supplemental/numberingSystems.json'),
  require(`cldr-data/main/es/ca-gregorian.json`),
  require(`cldr-data/main/es/numbers.json`),
  require(`cldr-data/main/es/timeZoneNames.json`),
  require(`cldr-data/main/en/ca-gregorian.json`),
  require(`cldr-data/main/en/numbers.json`),
  require(`cldr-data/main/en/timeZoneNames.json`),
  require(`cldr-data/main/fr/ca-gregorian.json`),
  require(`cldr-data/main/fr/numbers.json`),
  require(`cldr-data/main/fr/timeZoneNames.json`),
  require(`cldr-data/main/ca/ca-gregorian.json`),
  require(`cldr-data/main/ca/numbers.json`),
  require(`cldr-data/main/ca/timeZoneNames.json`),
  require(`cldr-data/main/eu/ca-gregorian.json`),
  require(`cldr-data/main/eu/numbers.json`),
  require(`cldr-data/main/eu/timeZoneNames.json`)
);

ReactDOM.render(
  // eslint-disable-next-line react/jsx-fragments
  <React.Fragment>
    <I18nextProvider>
      <App i18n={i18n} />
    </I18nextProvider>
  </React.Fragment>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
